import store from "@/store";
import { ApiBaseParams, Products, ApplianceList } from "@/types/common"
import NativeClient from "@/client/native-client";

export const isValidApiAccessToken = () => {
  const apiBaseParams: ApiBaseParams = store.getters["common/getApiBaseParams"];
  if (apiBaseParams.token != null && apiBaseParams.token != "") {
    return true;
  }
  return false;
}

export default class CommonUtil {
  static scroll(options?: ScrollToOptions) {
    if (NativeClient.isIOS()) {
      scrollTo(options);
    } else {
      scrollBy(options);
    }
  }
  static jsonStringify(obj: any) {
    return JSON.stringify(obj, (k, v) => {
      if (v instanceof Map) {
        return Object.fromEntries(v);
      }
      return v;
    })
  }
}

// remサイズからpxサイズに変換する
export const convertRemToPx = (rem: number) => {
  const fontSize = getComputedStyle(document.documentElement).fontSize;
  return rem * parseFloat(fontSize);
}

export const translateYYYYMMDDToJapan = (yyyyMMdd: string) => {
  // yyyyMMddは、"yyyy-MM-dd"の計s機
  return yyyyMMdd.substring(5, 7) + "月" + yyyyMMdd.substring(8) + "日";
}

export const translateYYYYMMDDToMDJapan = (yyyyMMdd: string) => {
  // yyyyMMddは、"yyyy-MM-dd"の計s機
  return `${parseInt(yyyyMMdd.substring(5, 7))}月${parseInt(yyyyMMdd.substring(8))}日`;
}

export const translateYYYYMMDDToYYYYMDJapan = (yyyyMMdd: string) => {
  // yyyyMMddは、"yyyy-MM-dd"
  return `${parseInt(yyyyMMdd.substring(0, 5))}年${parseInt(yyyyMMdd.substring(5, 7))}月${parseInt(yyyyMMdd.substring(8))}日`;
}

// 日付（yyyy-mm-dd）をmm/ddに変換する
export const translateYYYYMMDDToMMDD = (yyyyMMdd: string) => {
  // yyyyMMddは、"yyyy-MM-dd"の形式 ０を抜く
  const month = parseInt(yyyyMMdd.substring(5, 7), 10);
  const day = parseInt(yyyyMMdd.substring(8), 10);
  return `${month}/${day}`;
}

export const copyObject = (target: any) => {
  return JSON.parse(JSON.stringify(target));
};

export const getApplianceIdFindEoj = (eoj: string, applianceList: ApplianceList) => {
  NativeClient.sendDebugLog("getApplianceIdFindEoj eoj=" + eoj + " applianceList=" + JSON.stringify(applianceList));
  let applianceId = "";
  if (applianceList != null && applianceList.applianceList != null) {
    for (const item of applianceList.applianceList) {
      if (item.eoj == eoj) {
        applianceId = item.applianceId;
        break;
      }
    }
  }
  return applianceId;
};

